var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('route-navigation',[_c('bs-button',{staticClass:"btn-sm btn-info mr-2",attrs:{"to":{ name: 'Settings' }}},[_vm._v(_vm._s(_vm.$t('labels.nav.general')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }